import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=34bab9f4&scoped=true&"
import script from "./MoneyInput.vue?vue&type=script&lang=js&"
export * from "./MoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bab9f4",
  null
  
)

export default component.exports